export default __webpack_public_path__ + "static/indian-56f9b4d778dd0b31b921567c93613392.jpg";